"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionBillingStatus = void 0;
var SessionBillingStatus;
(function (SessionBillingStatus) {
    SessionBillingStatus["COMPED"] = "comped";
    SessionBillingStatus["REDUCED"] = "reduced_rate";
    SessionBillingStatus["DEFAULT"] = "default";
})(SessionBillingStatus || (exports.SessionBillingStatus = SessionBillingStatus = {}));
//# sourceMappingURL=SessionBillingStatus.js.map